import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Download from "../components/Download";
import ErrorMessage from "../components/ErrorMessage";
import Spinner from "../components/Spinner";
import { BASE_URL } from "../utils/config";
import { initialFormData } from "../utils/formData";
import { formLabel } from "../utils/formFieldLabels";

const DocumentPage = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const getStudent = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/student/admission/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const json = await response.json();
      console.log(json);
      if (json.status) {
        setFormData(json.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const navigate = useNavigate();


  useEffect(() => {
    document.title = "AUMS • Document";
    getStudent();

    if (formData?.document === null) {
      console.log("Null doc");
    } else {
      console.log("Not null doc");
    }

  }, []);


  
  const handleChange = (event, section, key) => {
    const file = event.target.value;

    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: { value: file }
      }
    }));

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[key];
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Photograph
    if (!formData.document.photograph.value) {
      newErrors.photograph = "Photograph is required";
    }

    // Transcript
    if (!formData.document.transcript.value) {
      newErrors.transcript = "Transcript is required";
    }

    // English Score
    if (!formData.document.englishscore.value) {
      newErrors.englishscore = "English score document is required";
    }

    // High School Certificate
    if (!formData.document.highschool.value) {
      newErrors.highschool = "High school certificate is required";
    }

    // Civil ID Front
    if (!formData.document.civilidFront.value) {
      newErrors.civilidFront = "Civil ID front copy is required";
    }

    // Civil ID Back
    if (!formData.document.civilidBack.value) {
      newErrors.civilidBack = "Civil ID back copy is required";
    }

    // Security Card Front and Back (for Non-Kuwaiti)
    if (
      formData.nationality &&
      formData.nationality.value &&
      formData.nationality.value.toLowerCase() === "non-kuwaiti"
    ) {
      if (!formData.document.securityCardFront.value) {
        newErrors.securityCardFront = "Security Card front copy is required";
      }
      if (!formData.document.securityCardBack.value) {
        newErrors.securityCardBack = "Security Card back copy is required";
      }
    }

    // Passport
    if (!formData.document.passport.value) {
      newErrors.passport = "Passport copy is required";
    }

    // Health Record
    if (!formData.document.record.value) {
      newErrors.record = "Health record is required";
    }

    // Good Conduct Certificate (optional)
    // Uncomment below to make it required
    // if (!formData.document.goodconduct.value) {
    //   newErrors.goodconduct = "Good conduct certificate is required";
    // }

    // Father's Civil ID
    if (!formData.document.fatherCivilId.value) {
      newErrors.fatherCivilId = "Father's Civil ID is required";
    }

    // Mother's Civil ID
    if (!formData.document.motherCivilId.value) {
      newErrors.motherCivilId = "Mother's Civil ID is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const submitForm = async () => {
    if (!validateForm()) {
      toast.error("Please upload all required documents.");
      return;
    }

    try {
      const docFile = new FormData();

      docFile.append("id", id);

      Object.keys(formData.document).forEach((key) => {
        const file = formData.document[key]?.value;
        if (file) {
          if (key === "securityCardFront") {
            docFile.append("securityFront", file);
          } else if (key === "securityCardBack") {
            docFile.append("securityBack", file);
          } else {
            docFile.append(key, file);
          }
        }
      });

      setIsLoading(true);

      const response = await fetch(`${BASE_URL}/student/admission/document/`, {
        method: "POST",
        body: docFile
      });

      const jsonDoc = await response.json();
      console.log(jsonDoc);

      if (jsonDoc.status) {
        toast.success("Form submitted successfully!");
        localStorage.removeItem("FormData");
        navigate("/");
      } else {
        toast.error("Submission failed. Please try again.");
         navigate("/document/:id");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Form submission failed!");
       navigate("/document/:id");
    } finally {
      setIsLoading(false);

    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          backgroundColor: "#b60041",
          padding: "1rem",
          fontWeight: "bold"
        }}
      >
        <h4 className="form">Required Documents {" / المستندات المطلوبة "}</h4>
      </Box>

      <Box sx={{ padding: "0.5rem", color: "#606060" }}>
        <Box>
          <h4 className="my-3 font-bold text-center">
            {formLabel.document.title.english}
          </h4>
        </Box>

        <TableContainer component={Paper}>
          <Table aria-label="documents-table">
            <TableHead className="w-full">
              {[
                {
                  label:
                    "Copy of Official grade transcript or certified copy - Original High school certificate",
                  key: "transcript"
                },
                {
                  label:
                    "Equivalency of high school degree issued by the Ministry of Education in Kuwait (for private school graduates)",
                  key: "highschool"
                },
                {
                  label:
                    "Valid IELTS/TOEFL score report (if available) (no older than two years)",
                  key: "englishscore"
                },
                {
                  label: "Copy of birth certificate",
                  key: "record"
                },
                {
                  label: "Good Conduct Certificate",
                  key: "goodconduct"
                },
                {
                  label: "Personal recent photo 4*6",
                  key: "photograph"
                }
              ].map(({ label, key }) => (
                <TableRow key={key}>
                  <TableCell sx={{ fontWeight: "700" }} align="left">
                    {label}
                    {errors[key] && (
                      <ErrorMessage errorMessage={errors[key]} />
                    )}
                  </TableCell>
                  <TableCell className="w-[300px]">
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={key}
                      errors={errors}
                    />
                  </TableCell>
                </TableRow>
              ))}

              {/* Civil ID and Passport */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                   Valid National Civil ID (no less than 3 months validity) and valid passport photocopies: 
                  <br />
                  1. Civil ID FRONT
                  {errors.civilidFront && (
                    <ErrorMessage errorMessage={errors.civilidFront} />
                  )}
                  <br />
                  2. Civil ID BACK
                  {errors.civilidBack && (
                    <ErrorMessage errorMessage={errors.civilidBack} />
                  )}
                  <br />
                  3. Passport Copy
                  {errors.passport && (
                    <ErrorMessage errorMessage={errors.passport} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"civilidFront"}
                      errors={errors}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"civilidBack"}
                      errors={errors}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"passport"}
                      errors={errors}
                    />
                  </Box>
                </TableCell>
              </TableRow>

              {/* Security Cards */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Valid Security Cards (for non-Kuwaitis):
                  <br />
                  1. FRONT
                  {errors.securityCardFront && (
                    <ErrorMessage errorMessage={errors.securityCardFront} />
                  )}
                  <br />
                  2. BACK
                  {errors.securityCardBack && (
                    <ErrorMessage errorMessage={errors.securityCardBack} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"securityCardFront"}
                      errors={errors}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"securityCardBack"}
                      errors={errors}
                    />
                  </Box>
                </TableCell>
              </TableRow>

              {/* Parents Civil IDs */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Parents/Guardian Civil IDs:
                  <br />
                  1. Father
                  {errors.fatherCivilId && (
                    <ErrorMessage errorMessage={errors.fatherCivilId} />
                  )}
                  <br />
                  2. Mother
                  {errors.motherCivilId && (
                    <ErrorMessage errorMessage={errors.motherCivilId} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"fatherCivilId"}
                      errors={errors}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"motherCivilId"}
                      errors={errors}
                    />
                  </Box>
                </TableCell>
              </TableRow>

              {/* Note */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Additional documents may be requested by the Admission Office.
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>

        {/* Submit Button */}
        <Box className="text-center mt-6">
          <button
            onClick={submitForm}
            className="bg-[#b60041] hover:bg-blue-600 px-6 py-3 text-white font-bold rounded"
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </Box>
      </Box>

      {isLoading && <Spinner />}
    </Box>
  );
};

export default DocumentPage;
